//import GA from "./GoogleAnalytics";
//import Plausible from "./Plausible";
//import SimpleAnalytics from "./SimpleAnalytics";
//import Umami from "./Umami";
//import siteMetadata from "@/data/siteMetadata";

import FBPixCodeScript from "./FacebookPixelCode";
import GACScript from "./GoogleAnalyticsCode";
import GTagScript from "./GoogleTagManagerCode";
import GTagNoScript from "./GTagNoScript";

const isProduction = process.env.NODE_ENV === "production";
//const { analytics } = siteMetadata;

const Analytics = (props) => (
  <>
    {/* {isProduction && analytics.plausibleDataDomain && <Plausible />}
      {isProduction && analytics.simpleAnalytics && <SimpleAnalytics />}
      {isProduction && analytics.umamiWebsiteId && <Umami />}
      {isProduction && analytics.googleAnalyticsId && <GA />} */}

    {isProduction && <FBPixCodeScript {...props} />}
    {isProduction && <GACScript {...props} />}
    {isProduction && <GTagScript {...props} />}
    {isProduction && <GTagNoScript {...props} />}
  </>
);

export default Analytics;
